/* ===========================================================================
   GLP Risk Calculator — Karespot
   Module 0b: engine. Steps, scoring, gauge, need-profile, share, lead submit.
   Pairs with assets/glp-calc.css and sections/glp-risk-calculator.liquid.
   =========================================================================== */
(function () {
  'use strict';

  var NEED_COLORS = { hydration: '#4F8E78', barrier: '#A6803F', firmness: '#32245F', renewal: '#CBA968' };

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* Safety net: the lead step uses a Shopify {% form 'customer' %}. If that form
     ever submits natively it reloads the page and wipes the whole quiz — which is
     what made a bad field restart everything. Block the native submit here in the
     capture phase so it can never happen, regardless of per-section init. The
     per-form handler below still runs to validate inputs and render the result. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.classList && f.classList.contains('glpc__leadform')) { e.preventDefault(); }
  }, true);

  function initOne(root) {
    if (root.dataset.bound) return;
    root.dataset.bound = '1';

    var steps = $all('.glpc__step', root);
    if (!steps.length) return;
    var idx = 0;
    var resultShownAt = 0;

    var progressBar = $('.glpc__progress-bar', root);
    var stepCount = $('.glpc__step-count', root);
    var qSteps = steps.filter(function (s) { return /^q\d+$/.test(s.getAttribute('data-step') || ''); });

    /* ---- tiers ---- */
    var tiers = $all('.glpc__tier-data', root).map(function (t) {
      return {
        min: parseFloat(t.getAttribute('data-min')),
        max: parseFloat(t.getAttribute('data-max')),
        label: t.getAttribute('data-label') || '',
        headline: t.getAttribute('data-headline') || '',
        message: t.getAttribute('data-message') || '',
        accent: t.getAttribute('data-accent') || '#A6803F'
      };
    });

    /* ---- max score (robust to edited weights) ---- */
    var scoredNames = ['q1', 'q2', 'q3', 'q4'];
    var maxScore = 0;
    scoredNames.forEach(function (name) {
      var m = 0;
      $all('input[name="' + name + '"]', root).forEach(function (o) {
        m = Math.max(m, parseFloat(o.getAttribute('data-score')) || 0);
      });
      maxScore += m;
    });
    var skinInputs = $all('input[name="skincare"]', root);
    maxScore += skinInputs.length * 0.75;
    maxScore = Math.round(maxScore);

    function checked(name) { return $('input[name="' + name + '"]:checked', root); }

    /* ---- navigation ---- */
    function show(i) {
      idx = Math.max(0, Math.min(i, steps.length - 1));
      steps.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      var pct = steps.length > 1 ? (idx / (steps.length - 1)) * 100 : 0;
      if (progressBar) progressBar.style.width = pct + '%';
      var ds = steps[idx].getAttribute('data-step');
      if (stepCount) {
        var qm = /^q(\d+)$/.exec(ds);
        if (qm) { stepCount.textContent = 'Question ' + qm[1] + ' of ' + qSteps.length; stepCount.style.display = ''; }
        else { stepCount.style.display = 'none'; }
      }
      try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    }

    function stepValid(step) {
      var ds = step.getAttribute('data-step');
      if (/^q\d+$/.test(ds)) {
        var radios = $all('input[type="radio"]', step);
        if (radios.length) return radios.some(function (r) { return r.checked; });
      }
      return true; // multi-select / lead handled separately
    }

    function go(delta) {
      if (delta > 0 && !stepValid(steps[idx])) { flash(steps[idx]); return; }
      show(idx + delta);
    }

    function flash(step) {
      var opts = $('.glpc__opts', step);
      if (!opts) return;
      opts.animate(
        [{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }],
        { duration: 280 }
      );
    }

    root.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-act]');
      if (!nav || !root.contains(nav)) return;
      var act = nav.getAttribute('data-act');
      if (act === 'next') { e.preventDefault(); go(1); }
      else if (act === 'back') { e.preventDefault(); go(-1); }
      else if (act === 'redo') {
        e.preventDefault();
        // Ignore a redo tap that lands right as the result appears, so the result
        // can't be wiped by the same gesture/scroll that revealed it.
        if (Date.now() - resultShownAt < 1200) return;
        resetAll();
      }
    });

    // enable Next when a radio is chosen in the current step
    root.addEventListener('change', function (e) {
      if (e.target.type === 'radio') {
        var step = e.target.closest('.glpc__step');
        if (!step) return;
        var nextBtn = $('[data-act="next"]', step);
        if (nextBtn) nextBtn.removeAttribute('disabled');
      }
    });

    /* ---- scoring ---- */
    function compute() {
      var score = 0;
      scoredNames.forEach(function (name) {
        var el = checked(name);
        if (el) score += parseFloat(el.getAttribute('data-score')) || 0;
      });
      var gaps = [];
      var missing = { spf: false, barrier: false, retinol: false, vitc: false };
      skinInputs.forEach(function (inp) {
        if (!inp.checked) {
          score += 0.75;
          var k = inp.getAttribute('data-key');
          if (k && k in missing) missing[k] = true;
          if (inp.getAttribute('data-gap')) gaps.push(inp.getAttribute('data-gap'));
        }
      });
      score = Math.round(score);
      if (score > maxScore) score = maxScore;
      if (score < 0) score = 0;

      var tier = null;
      for (var i = 0; i < tiers.length; i++) {
        if (score >= tiers[i].min && score <= tiers[i].max) { tier = tiers[i]; break; }
      }
      if (!tier) tier = tiers[tiers.length - 1] || { label: '', headline: '', message: '', accent: '#A6803F' };

      var q1 = num(checked('q1')), q2 = num(checked('q2')), q3 = num(checked('q3')), q4 = num(checked('q4'));
      var needs = {
        hydration: pct(q1 + q2 + (missing.barrier ? 1.5 : 0), 6.5),
        barrier: pct((missing.spf ? 1.5 : 0) + (missing.barrier ? 1.5 : 0) + q4 * 0.5, 4.5),
        firmness: pct(q2 + q3 + (missing.retinol ? 1.5 : 0) + q4 * 0.5, 8),
        renewal: pct(q1 + q3 + (missing.vitc ? 1 : 0) + q4 * 0.5, 8.5)
      };

      var goalEl = checked('goal');
      return {
        score: score, max: maxScore, tier: tier, gaps: gaps, needs: needs,
        goal: goalEl ? (goalEl.getAttribute('data-note') || '') : ''
      };
    }
    function num(el) { return el ? (parseFloat(el.getAttribute('data-score')) || 0) : 0; }
    function pct(raw, max) { var v = Math.round((raw / max) * 100); return Math.max(10, Math.min(100, v)); }

    /* ---- result render ---- */
    var lastResult = null;
    function renderResult(r) {
      lastResult = r;
      root.style.setProperty('--gc-accent', r.tier.accent);

      // gauge
      var fill = $('.glpc__gauge-fill', root);
      if (fill) {
        var rad = parseFloat(fill.getAttribute('r')) || 86;
        var circ = 2 * Math.PI * rad;
        fill.style.strokeDasharray = circ;
        fill.style.strokeDashoffset = circ;
        var ratio = r.max ? r.score / r.max : 0;
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          fill.style.strokeDashoffset = circ * (1 - ratio);
        }); });
      }
      countUp($('.glpc__gauge-num', root), r.score);
      var den = $('.glpc__gauge-den', root); if (den) den.textContent = '/ ' + r.max;

      setText('.glpc__tier', r.tier.label);
      setText('.glpc__r-headline', r.tier.headline);
      setText('.glpc__r-msg', r.tier.message);

      // need bars
      $all('.glpc__need', root).forEach(function (need) {
        var key = need.getAttribute('data-need');
        var span = $('.glpc__need-bar span', need);
        if (!span) return;
        span.style.background = NEED_COLORS[key] || r.tier.accent;
        var target = (r.needs[key] || 0) + '%';
        requestAnimationFrame(function () { requestAnimationFrame(function () { span.style.width = target; }); });
      });

      // gaps
      var gapWrap = $('.glpc__gaps', root);
      if (gapWrap) {
        gapWrap.innerHTML = '';
        if (r.gaps.length) {
          var h = document.createElement('li'); h.className = 'glpc__gaps-h'; h.style.listStyle = 'none';
          h.textContent = 'Gaps in your current routine';
          // header rendered separately to avoid bullet
          var head = $('.glpc__gaps-head', root);
          if (head) head.style.display = '';
          r.gaps.forEach(function (g) { var li = document.createElement('li'); li.textContent = g; gapWrap.appendChild(li); });
        } else {
          var head2 = $('.glpc__gaps-head', root); if (head2) head2.style.display = 'none';
        }
      }

      // CTA
      var cta = $('.glpc__r-cta', root);
      if (cta) {
        var url = root.getAttribute('data-product-url');
        if (url) cta.setAttribute('href', url);
      }
    }

    function setText(sel, txt) { var el = $(sel, root); if (el) el.textContent = txt || ''; }
    function countUp(el, target) {
      if (!el) return;
      var start = null, dur = 1100, from = 0;
      function frame(ts) {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(from + (target - from) * eased);
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    /* ---- lead field helpers ---- */
    function field(key) { var el = $('[data-field="' + key + '"]', root); return el ? el.value.trim() : ''; }
    function digits(s) { return (s || '').replace(/[^0-9]/g, ''); }

    // Required lead fields. Email and mobile are both mandatory.
    var LEAD_TESTS = {
      name: function (v) { return v.length >= 2; },
      email: function (v) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v); },
      phone: function (v) { return digits(v).length >= 7; }
    };

    function checkField(key, test) {
      var el = $('[data-field="' + key + '"]', root);
      if (!el) return true;
      var err = $('.glpc__field-err[data-for="' + key + '"]', root);
      var good = test(el.value.trim());
      el.classList.toggle('is-invalid', !good);
      if (err) err.classList.toggle('is-shown', !good);
      return good;
    }

    function consentEl() { return $('.glpc__consent input', root); }

    function validateLead() {
      var ok = true;
      ok = checkField('name', LEAD_TESTS.name) && ok;
      ok = checkField('email', LEAD_TESTS.email) && ok;
      ok = checkField('phone', LEAD_TESTS.phone) && ok;
      var consent = consentEl();
      var consentErr = $('.glpc__consent-err', root);
      if (consent && !consent.checked) { if (consentErr) consentErr.classList.add('is-shown'); ok = false; }
      else if (consentErr) consentErr.classList.remove('is-shown');
      return ok;
    }

    // Quiet check (no error display) used to gate the unlock button live.
    function leadComplete() {
      var consent = consentEl();
      return LEAD_TESTS.name(field('name'))
        && LEAD_TESTS.email(field('email'))
        && LEAD_TESTS.phone(field('phone'))
        && !!(consent && consent.checked);
    }

    /* ---- lead submit ---- */
    var leadForm = $('.glpc__leadform', root);
    var unlockBtn = leadForm ? (leadForm.querySelector('.glpc__btn--gold') || leadForm.querySelector('button[type="submit"]')) : null;

    // Decouple the unlock control from native form submission entirely, and keep
    // it disabled until the form is genuinely complete.
    if (unlockBtn) {
      unlockBtn.setAttribute('type', 'button');
      unlockBtn.setAttribute('disabled', '');
    }

    function refreshUnlockState() {
      if (!unlockBtn) return;
      if (leadComplete()) unlockBtn.removeAttribute('disabled');
      else unlockBtn.setAttribute('disabled', '');
    }
    function clearFieldIfValid(key) {
      if (!LEAD_TESTS[key]) return;
      var el = $('[data-field="' + key + '"]', root);
      if (!el) return;
      if (LEAD_TESTS[key](el.value.trim())) {
        el.classList.remove('is-invalid');
        var err = $('.glpc__field-err[data-for="' + key + '"]', root);
        if (err) err.classList.remove('is-shown');
      }
    }

    function submitLead() {
      if (!validateLead()) {
        // Keep every answer exactly as-is; just surface the first problem
        // (bad email, empty mobile, unticked box) instead of reloading the quiz.
        var firstErr = $('.glpc__field-err.is-shown, .glpc__consent-err.is-shown', root);
        if (firstErr) { try { firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (er) {} }
        return;
      }
      var r = compute();

      // build tags incl. phone + score + tier so it's all on the customer record
      var slug = (r.tier.label || 'result').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      var phone = digits(field('phone'));
      var cc = digits(field('cc'));
      var fullPhone = (cc ? '+' + cc : '') + phone;
      var tagsEl = $('.glpc__tags', root);
      if (tagsEl) {
        tagsEl.value = ['glp-skin-quiz', 'risk-' + slug, 'score-' + r.score + '-of-' + r.max, 'phone-' + fullPhone].join(', ');
      }
      var phoneEl = $('.glpc__phone-hidden', root);
      if (phoneEl) phoneEl.value = fullPhone;

      // fire-and-continue: don't block the result on the network
      try {
        var body = new URLSearchParams(new FormData(leadForm));
        fetch(leadForm.getAttribute('action') || '/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'text/html' },
          body: body.toString()
        }).catch(function () {});
      } catch (err) {}

      var resultIdx = steps.indexOf($('.glpc__step[data-step="result"]', root));
      renderResult(r);
      show(resultIdx >= 0 ? resultIdx : steps.length - 1);
      resultShownAt = Date.now();
    }

    if (leadForm) {
      leadForm.setAttribute('novalidate', 'novalidate');
      // Enter key would natively submit + reload; route it through JS instead.
      leadForm.addEventListener('submit', function (e) { e.preventDefault(); submitLead(); });
      if (unlockBtn) unlockBtn.addEventListener('click', function (e) { e.preventDefault(); submitLead(); });

      // Live: clear an error as soon as a field becomes valid, and keep the
      // unlock button enabled only while the whole form is complete.
      leadForm.addEventListener('input', function (e) {
        var key = e.target.getAttribute('data-field');
        if (key) clearFieldIfValid(key);
        refreshUnlockState();
      });
      leadForm.addEventListener('change', function (e) {
        if (e.target.closest('.glpc__consent') && e.target.checked) {
          var consentErr = $('.glpc__consent-err', root);
          if (consentErr) consentErr.classList.remove('is-shown');
        }
        refreshUnlockState();
      });
      // Surface a field's error when the user leaves it incomplete.
      leadForm.addEventListener('blur', function (e) {
        var key = e.target.getAttribute('data-field');
        if (key === 'name' || key === 'email' || key === 'phone') checkField(key, LEAD_TESTS[key]);
      }, true);

      refreshUnlockState();
    }

    /* ---- share ---- */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-share]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      var mode = btn.getAttribute('data-share');
      if (mode === 'copy') return copyLink(btn);
      buildImage(function (blob, dataUrl) {
        if (mode === 'image') return downloadImage(dataUrl);
        if (mode === 'native') return nativeShare(blob);
      });
    });

    function shareUrl() { return root.getAttribute('data-share-url') || location.href.split('#')[0]; }
    function shareTitle() { return root.getAttribute('data-share-title') || 'My GLP-1 Skin Risk result'; }

    function copyLink(btn) {
      var url = shareUrl();
      var done = function () { var t = btn.querySelector('span'); if (t) { var o = t.textContent; t.textContent = 'Copied!' ; setTimeout(function () { t.textContent = o; }, 1600); } };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, done);
      else { try { var ta = document.createElement('textarea'); ta.value = url; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); done(); } catch (e) {} }
    }

    function nativeShare(blob) {
      var data = { title: shareTitle(), text: shareTitle() + ' — take the 60-second skin check:', url: shareUrl() };
      if (blob && navigator.canShare) {
        var file = new File([blob], 'karespot-skin-risk.png', { type: 'image/png' });
        if (navigator.canShare({ files: [file] })) data.files = [file];
      }
      if (navigator.share) navigator.share(data).catch(function () {});
      else copyLink({ querySelector: function () { return null; } });
    }

    function downloadImage(dataUrl) {
      var a = document.createElement('a');
      a.href = dataUrl; a.download = 'karespot-skin-risk.png';
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
    }

    function buildImage(cb) {
      var r = lastResult; if (!r) return;
      var canvas = $('.glpc__sharecanvas', root) || document.createElement('canvas');
      var W = 640, H = 800, s = 2;
      canvas.width = W * s; canvas.height = H * s;
      var c = canvas.getContext('2d'); c.scale(s, s);
      var name = field('name');

      c.fillStyle = '#FBF6EC'; c.fillRect(0, 0, W, H);
      c.fillStyle = '#32245F'; c.fillRect(0, 0, W, 8);
      // wordmark
      c.fillStyle = '#A6803F'; c.font = '600 18px Georgia, serif';
      c.textAlign = 'center'; c.fillText('K A R E S P O T', W / 2, 70);
      c.fillStyle = '#1A1726'; c.font = '600 34px Georgia, serif';
      c.fillText('GLP-1 Skin Risk', W / 2, 120);
      if (name) { c.fillStyle = '#5C5870'; c.font = '400 17px Arial, sans-serif'; c.fillText(name + '\u2019s personalised result', W / 2, 152); }

      // ring
      var cx = W / 2, cy = 348, rad = 120;
      c.lineWidth = 22; c.lineCap = 'round';
      c.strokeStyle = 'rgba(50,36,95,.10)';
      c.beginPath(); c.arc(cx, cy, rad, 0, Math.PI * 2); c.stroke();
      var ratio = r.max ? r.score / r.max : 0;
      c.strokeStyle = r.tier.accent;
      c.beginPath(); c.arc(cx, cy, rad, -Math.PI / 2, -Math.PI / 2 + ratio * Math.PI * 2); c.stroke();
      c.fillStyle = r.tier.accent; c.font = '600 72px Georgia, serif';
      c.fillText(String(r.score), cx, cy + 12);
      c.fillStyle = '#5C5870'; c.font = '400 20px Arial, sans-serif';
      c.fillText('out of ' + r.max, cx, cy + 46);

      // tier
      c.fillStyle = r.tier.accent; c.font = '700 16px Arial, sans-serif';
      c.fillText((r.tier.label || '').toUpperCase(), cx, 520);
      c.fillStyle = '#1A1726'; c.font = '500 26px Georgia, serif';
      wrap(c, r.tier.headline, cx, 558, 520, 32);

      // footer
      c.fillStyle = '#32245F'; c.font = '600 17px Arial, sans-serif';
      c.fillText('Are you at risk? Take the 60-second check', cx, H - 70);
      c.fillStyle = '#A6803F'; c.font = '700 18px Arial, sans-serif';
      c.fillText('karespot.shop', cx, H - 42);

      var dataUrl = canvas.toDataURL('image/png');
      if (canvas.toBlob) canvas.toBlob(function (b) { cb(b, dataUrl); }, 'image/png');
      else cb(null, dataUrl);
    }

    function wrap(c, text, x, y, maxW, lh) {
      if (!text) return;
      var words = String(text).split(' '), line = '', lines = [];
      for (var i = 0; i < words.length; i++) {
        var test = line + words[i] + ' ';
        if (c.measureText(test).width > maxW && line) { lines.push(line.trim()); line = words[i] + ' '; }
        else line = test;
      }
      lines.push(line.trim());
      for (var j = 0; j < lines.length; j++) c.fillText(lines[j], x, y + j * lh);
    }

    /* ---- reset ---- */
    function resetAll() {
      $all('input', root).forEach(function (i) {
        if (i.type === 'radio' || i.type === 'checkbox') i.checked = false;
        else if (!i.name || i.name.indexOf('form_type') < 0 && i.name.indexOf('utf8') < 0) i.value = '';
      });
      $all('[data-act="next"]', root).forEach(function (b) { b.setAttribute('disabled', ''); });
      $all('.is-invalid', root).forEach(function (el) { el.classList.remove('is-invalid'); });
      $all('.glpc__field-err.is-shown, .glpc__consent-err.is-shown', root).forEach(function (el) { el.classList.remove('is-shown'); });
      var fill = $('.glpc__gauge-fill', root); if (fill) fill.style.strokeDashoffset = fill.style.strokeDasharray || '1';
      $all('.glpc__need-bar span', root).forEach(function (s) { s.style.width = '0'; });
      if (unlockBtn) unlockBtn.setAttribute('disabled', '');
      resultShownAt = 0;
      show(0);
    }

    // disable Next buttons on radio steps initially
    qSteps.forEach(function (s) {
      var hasRadio = $('input[type="radio"]', s);
      var nextBtn = $('[data-act="next"]', s);
      if (hasRadio && nextBtn) nextBtn.setAttribute('disabled', '');
    });

    show(0);
  }

  function initAll(scope) { $all('.glpc', scope || document).forEach(initOne); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
